'use strict';

const Header = {

    init: function () {
        const header = document.querySelector('.header');
        if (header) {
            const openBtn = header.querySelector('.js-open-menu');
            const closeBtn = header.querySelector('.js-close-menu');
            openBtn.addEventListener('click', () => {
                if (!header.classList.contains('open')) {
                    header.classList.add('open');
                    document.querySelector('html').style.overflow = "hidden"
                }
            })
            closeBtn.addEventListener('click', () => {
                if (header.classList.contains('open')) {
                    header.classList.remove('open')
                    document.querySelector('html').style.overflow = "visible"
                }
            })
        }
    }
};

export default Header;
